export const init = () => {
    if (document.querySelector('.s-image_link-gallery')) {
        const sections = document.querySelectorAll('.s-image_link-gallery:not(.s-image_link-gallery--crossroad-menu,.s-image_link-gallery--icon-topics)');
        setItemWidth(sections);
        window.addEventListener('resize', () => {
            setItemWidth(sections);
        });
    }
    function setItemWidth(sections) {
        sections.forEach((section) => {
            const items = section.querySelectorAll('.s-image_link-gallery__item');
            let smallestWidth = Number.MAX_VALUE;
            items.forEach((item) => {
                if (item.getBoundingClientRect().width < smallestWidth) {
                    smallestWidth = item.getBoundingClientRect().width;
                }
            });
            items.forEach((item) => {
                try {
                    const text = item.querySelector('.s-image_link-gallery__text-wrapper');
                    text.style.maxWidth = smallestWidth + 'px';
                    text.style.textOverflow = "ellipsis";
                    text.style.overflow = 'hidden';
                }
                catch(e) {
                    console.log(`exception thrown: ${e}`);
                }
            });
        }); 
    };  
};